(function () {
  'use strict';

  var busy = false;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function cartRoot() {
    return qs(document, '[data-wg-cart]');
  }

  function sectionIds() {
    return qsa(document, '[data-wg-cart-refresh]')
      .map(function (el) {
        return el.getAttribute('data-wg-cart-refresh');
      })
      .filter(Boolean);
  }

  function showError(on) {
    var el = qs(document, '[data-wg-cart-error]');
    if (!el) return;
    el.hidden = !on;
  }

  function updateHeaderCount(count) {
    var bag = qs(document, '.wg-header__bag');
    if (!bag) return;
    var badge = qs(bag, '.wg-header__count');
    var n = Number(count || 0);
    if (n > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wg-header__count';
        bag.appendChild(badge);
      }
      badge.textContent = String(n);
    } else if (badge) {
      badge.remove();
    }
  }

  function replaceSection(id, html) {
    var current = document.getElementById('shopify-section-' + id);
    if (!current || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('shopify-section-' + id);
    current.innerHTML = next ? next.innerHTML : html;
  }

  function setLineBusy(line, on) {
    if (!line) return;
    line.classList.toggle('is-busy', !!on);
    qsa(line, 'button, input').forEach(function (el) {
      el.disabled = !!on;
    });
  }

  function changeCart(payload, line) {
    if (busy) return Promise.resolve();
    busy = true;
    showError(false);
    setLineBusy(line, true);
    var ids = sectionIds();
    var body = {
      id: payload.id,
      quantity: payload.quantity
    };
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = '/cart';
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart change failed');
        return res.json();
      })
      .then(function (data) {
        updateHeaderCount(data.item_count);
        if (data.sections) {
          ids.forEach(function (id) {
            if (data.sections[id]) replaceSection(id, data.sections[id]);
          });
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        showError(true);
        setLineBusy(line, false);
      })
      .then(function () {
        busy = false;
      });
  }

  function lineFrom(el) {
    return el ? el.closest('[data-wg-cart-line]') : null;
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-wg-cart-remove]');
    if (remove) {
      event.preventDefault();
      var line = lineFrom(remove);
      if (!line) return;
      changeCart({ id: line.getAttribute('data-key'), quantity: 0 }, line);
      return;
    }

    var qtyBtn = event.target.closest('[data-wg-cart-qty]');
    if (!qtyBtn) return;
    event.preventDefault();
    var row = lineFrom(qtyBtn);
    if (!row) return;
    var input = qs(row, '[data-wg-cart-qty-input]');
    var current = Number((input && input.value) || row.getAttribute('data-qty') || 1);
    var delta = Number(qtyBtn.getAttribute('data-wg-cart-qty') || 0);
    var next = current + delta;
    if (next < 1) next = 1;
    var max = input ? Number(input.getAttribute('max') || 99) : 99;
    if (next > max) next = max;
    if (next === current) return;
    changeCart({ id: row.getAttribute('data-key'), quantity: next }, row);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-wg-cart-qty-input]');
    if (!input) return;
    var row = lineFrom(input);
    if (!row) return;
    var next = parseInt(input.value, 10);
    if (isNaN(next) || next < 1) next = 1;
    var max = Number(input.getAttribute('max') || 99);
    if (next > max) next = max;
    changeCart({ id: row.getAttribute('data-key'), quantity: next }, row);
  });
})();
